interface AdjustedCrop {
  x: number;
  y: number;
  width: number;
  height: number;
  aspect: number;
}

export default (crop: any, naturalDimensions: any, resizedDimensions: any): AdjustedCrop => {
  const widthRatio = naturalDimensions.width / resizedDimensions.width;
  const heightRatio = naturalDimensions.height / resizedDimensions.height;

  return {
    aspect: crop.aspect,
    x: Math.round(crop.x * widthRatio),
    y: Math.round(crop.y * heightRatio),
    width: Math.round(crop.width * widthRatio),
    height: Math.round(crop.height * heightRatio),
  };
};
